export const COMPARE_PRODUCTS = 'COMPARE_PRODUCTS'

export const compareProducts = (products) => ({
  type: COMPARE_PRODUCTS,
  payload: products
})
